<template>
    <div>
      <slot :list="list" :styles="styles"></slot>
    </div>
</template>
<script>
  import { getCookie } from '@/store/cookies.js'
  export default {
    data() {
      return {
        styles: {
          height: '44px'
        },
        list: [
          {
            name: '首页',
            url: '/home'
          },
          {
            name: '课程',
            url: '/course',
            auth: true
          },
          {
            name: '培训信息',
            url: '/trainList'
          },
          {
            name: '新闻资讯',
            url: '/newsList'
          }
        ]
      }
    },
    created () {
      if (getCookie(process.env.TOKEN_KEY)) {
        this.list[1].auth = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/nav/containerNav.vue